import React from "react";
import { Routes, Route } from "react-router-dom";
import List from "./List";
import Edit from "./Edit";

export default function AssistantPlansRouter() {
    return (
        <Routes>
            <Route index element={<List />} />
            <Route path="create" element={<Edit />} />
            <Route path=":id" element={<Edit />} />
        </Routes>
    );
}
